import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {breakpoints, spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  container: css`
    position: relative;
    margin: 0;
    block-size: ${spacing(9)};
    inline-size: ${spacing(9)};
    border-radius: ${spacing(2)};
    background-color: ${cssTheme.colors.deliveryGrey[300]};

    ${breakpoints.up('sm')} {
      @media (hover: hover) {
        > button {
          display: none;
        }
      }

      &:hover > button {
        display: inherit;
      }
    }
  `,
  icon: css`
    color: ${cssTheme.default.day.textInvert};
  `,
  fileNameContainer: css`
    max-inline-size: 100%;
  `,
  fileName: css`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  deleteButton: css`
    inset-block-start: ${spacing(-0.5)};
    inset-inline-end: ${spacing(-0.5)};
    position: absolute;
    color: ${cssTheme.default.day.background};
    background-color: ${cssTheme.default.day.error};
  `,
}
